export const getNotifications = state => state.app.snackbar.notifications;